<!-- Nishwik feedback center: new admin workspace; legacy parent and classic views retained below. -->
<ng-container *ngIf="isSchoolAdmin">
<div class="nfc container-fluid px-4 py-4">
  <div class="nfc-page-head">
    <div>
      <div class="nfc-eyebrow">PARENT VOICE · SCHOOL IMPROVEMENT</div>
      <h2>Teacher Feedback Center</h2>
      <p>Understand parent feedback, review concerns fairly, and close the loop.</p>
    </div>
    <div class="nfc-header-actions">
      <button type="button" class="nfc-button" (click)="feedbackCenterOpenPrivacy()"><i class="bi bi-shield-check"></i> Privacy &amp; fairness</button>
      <button type="button" class="nfc-button nfc-primary" (click)="feedbackCenterExport()" [disabled]="schoolFeedbackLoading || !!schoolFeedbackError || schoolFeedbackPartial"><i class="bi bi-download"></i> Export report</button>
      
    </div>
  </div>

  <div class="nfc-scope">
    <label>School <span class="nfc-scope-value">{{ feedbackCenterSchoolName || (feedbackCenterSchoolNameLoading ? 'Loading school...' : 'School name unavailable') }}</span></label>
    <label>Academic year
      <select [(ngModel)]="feedbackCenterYear" (ngModelChange)="feedbackCenterChangeFilters()" aria-label="Academic year">
        <option value="all">All available</option>
        <option *ngFor="let year of feedbackCenterYearOptions" [value]="year">{{ year }}</option>
      </select>
    </label>
    <label>Date range
      <select [(ngModel)]="feedbackCenterPeriod" (ngModelChange)="feedbackCenterChangeFilters()" aria-label="Date range">
        <option value="all">All available</option>
        <option value="30">Last 30 days</option>
        <option value="7">Last 7 days</option>
      </select>
    </label>
    <label class="nfc-scope-search">Search feedback
      <input type="search" [(ngModel)]="feedbackCenterQuery" (ngModelChange)="feedbackCenterChangeFilters()" placeholder="Teacher, topic or comment..." aria-label="Search feedback" />
    </label>
    <button type="button" class="nfc-button" (click)="feedbackCenterResetFilters()"><i class="bi bi-arrow-counterclockwise"></i> Reset</button>
    <button type="button" class="nfc-button" (click)="loadSchoolFeedbackDashboard(); loadTeachersBySchool(schoolId)"><i class="bi bi-arrow-clockwise"></i> Refresh</button>
  </div>

  <div class="nfc-tabs" role="tablist" aria-label="Teacher Feedback Views">
    <button type="button" role="tab" [attr.aria-selected]="feedbackCenterTab === 'overview' && !selectedFeedbackProfile" [class.active]="feedbackCenterTab === 'overview' && !selectedFeedbackProfile" (click)="feedbackCenterChangeTab('overview')">Overview</button>
    <button type="button" role="tab" [attr.aria-selected]="feedbackCenterTab === 'teachers'" [class.active]="feedbackCenterTab === 'teachers'" (click)="feedbackCenterChangeTab('teachers')">Teachers <span>{{ teacherGridList.length }}</span></button>
    <button type="button" role="tab" [attr.aria-selected]="feedbackCenterTab === 'inbox'" [class.active]="feedbackCenterTab === 'inbox'" (click)="feedbackCenterChangeTab('inbox')">Feedback Inbox <span>{{ feedbackCenterScopeRecords.length }}</span></button>
    <button type="button" role="tab" [attr.aria-selected]="feedbackCenterTab === 'followups'" [class.active]="feedbackCenterTab === 'followups'" (click)="feedbackCenterChangeTab('followups')">Follow-ups <span>{{ feedbackCenterFollowupRecords.length }}</span></button>
  </div>

  <div class="nfc-loader" *ngIf="schoolFeedbackLoading || isTeacherGridLoading">
    <div class="spinner-border spinner-border-sm text-primary"></div> Loading school feedback from Nishwik APIs...
  </div>
  <div class="nfc-error" *ngIf="!schoolFeedbackLoading && schoolFeedbackError"><i class="bi bi-exclamation-triangle"></i> {{ schoolFeedbackError }}</div>
  <div class="nfc-error" *ngIf="!isTeacherGridLoading && teacherGridError"><i class="bi bi-exclamation-triangle"></i> {{ teacherGridError }}</div>
  <div class="nfc-note" *ngIf="!schoolFeedbackLoading && schoolFeedbackPartial">
    <i class="bi bi-info-circle"></i> The feedback API returned {{ schoolFeedbackRecords.length }} of {{ schoolFeedbackRecordsCount }} records. Counts and averages below reflect only the returned records; full reporting requires paginated API retrieval.
  </div>

  <ng-container *ngIf="!schoolFeedbackLoading && !schoolFeedbackError && !isTeacherGridLoading">
    <ng-container *ngIf="selectedFeedbackProfile as teacher; else feedbackCenterTopLevel">
      <button type="button" class="nfc-button nfc-back" (click)="selectedFeedbackProfile = null"><i class="bi bi-arrow-left"></i> All teachers</button>
      <div class="nfc-card nfc-profile-hero">
        <div class="nfc-person-circle nfc-large">{{ feedbackCenterInitials(teacher.fullName) }}</div>
        <div><div class="nfc-eyebrow">TEACHER FEEDBACK PROFILE</div><h3>{{ teacher.fullName }}</h3><p>{{ teacher.designation || 'Teaching Staff' }} · {{ feedbackCenterTeacherRecords(teacher.id).length }} feedback records</p></div>
        <span class="nfc-pill nfc-new ms-auto" *ngIf="feedbackCenterOpenCount(teacher.id) > 0">{{ feedbackCenterOpenCount(teacher.id) }} items for review</span>
      </div>
      <div class="nfc-two-columns nfc-profile-cols">
        <section class="nfc-card nfc-pad">
          <h3>Teacher feedback snapshot</h3><p class="nfc-muted">Sample size is always visible. Restricted ratings are excluded.</p>
          <div class="nfc-rating-big">{{ feedbackCenterAverage(feedbackCenterTeacherRecords(teacher.id)) === null ? '—' : feedbackCenterAverage(feedbackCenterTeacherRecords(teacher.id)) }}<small> / 5</small>
            <span class="nfc-muted">{{ feedbackCenterOrdinary(feedbackCenterTeacherRecords(teacher.id)).length }} rated reviews</span>
          </div>
          <div class="nfc-rating-row" *ngFor="let n of [5,4,3,2,1]">
            <span>{{ n }} ★</span><div class="nfc-track"><div class="nfc-fill" [style.width.%]="feedbackCenterRatingPercent(feedbackCenterTeacherRecords(teacher.id), n)"></div></div><span>{{ feedbackCenterRatingCount(feedbackCenterTeacherRecords(teacher.id), n) }}</span>
          </div>
          <p class="nfc-note mt-3">These ratings describe submitted feedback only. Do not use small or unequal samples to rank teachers.</p>
        </section>
        <section class="nfc-card nfc-pad">
          <h3>Actions and context</h3><p class="nfc-muted">Read-only view of statuses supplied by the feedback API.</p>
          <div class="nfc-mini-stats">
            <div><strong>{{ feedbackCenterOpenCount(teacher.id) }}</strong><small>Attention status</small></div>
            <div><strong>{{ feedbackCenterTeacherRecords(teacher.id).length - feedbackCenterOpenCount(teacher.id) }}</strong><small>Other statuses</small></div>
          </div>
          <div class="nfc-note"><i class="bi bi-shield-check"></i> Parent identity is protected in this administrative view. A verified assignment, audit and resolution history needs a dedicated backend workflow.</div>
          <button type="button" class="nfc-button nfc-outline mt-3" (click)="feedbackCenterChangeTab('followups')">View school-wide follow-ups <i class="bi bi-arrow-right"></i></button>
        </section>
      </div>
      <section class="nfc-card nfc-pad">
        <h3>Feedback history</h3><p class="nfc-muted">{{ feedbackCenterTeacherRecords(teacher.id).length }} records for this teacher within the selected period</p>
        <div class="nfc-empty" *ngIf="feedbackCenterTeacherRecords(teacher.id).length === 0">No feedback has been returned for this teacher in the selected period.</div>
        <ng-container *ngFor="let record of feedbackCenterTeacherRecords(teacher.id)">
          <div class="nfc-history-card">
            <div class="nfc-person"><div class="nfc-person-circle">{{ feedbackCenterInitials(teacher.fullName) }}</div><div><strong>{{ teacher.fullName }}</strong><small>{{ teacher.designation || 'Teaching Staff' }}</small></div></div>
            <span class="nfc-pill" [ngClass]="feedbackCenterStatusClass(record)">{{ feedbackCenterStatusLabel(record) }}</span>
            <div class="nfc-meta">{{ record.createdOn | date : 'dd MMM yyyy' }} · {{ feedbackCenterCategory(record) }} · Parent identity protected</div>
            <div class="nfc-stars" *ngIf="!isFeedbackCenterRestricted(record)">{{ record.rating }} / 5 ★</div>
            <p>{{ isFeedbackCenterRestricted(record) ? 'Restricted feedback — use authorized safeguarding access.' : (record.feedback || 'No comment supplied.') }}</p>
            <div class="nfc-history-footer"><small>Reference #FB-{{ record.feedbackId }}</small><button type="button" class="nfc-button nfc-outline nfc-small" (click)="feedbackCenterOpenRecord(record)">Open feedback <i class="bi bi-arrow-right"></i></button></div>
          </div>
        </ng-container>
      </section>
    </ng-container>

    <ng-template #feedbackCenterTopLevel>
      <ng-container *ngIf="feedbackCenterTab === 'overview'">
        <div class="nfc-metrics">
          <div class="nfc-metric"><div>Feedback received <i class="bi bi-chat-left-text"></i></div><strong>{{ feedbackCenterScopeRecords.length }}</strong><button (click)="feedbackCenterChangeTab('inbox')">View →</button></div>
          <div class="nfc-metric"><div>Teachers with feedback <i class="bi bi-people"></i></div><strong>{{ feedbackCenterTeachersWithReviews }}</strong><button (click)="feedbackCenterChangeTab('teachers')">View →</button></div>
          <div class="nfc-metric"><div>Awaiting first review <i class="bi bi-clock-history"></i></div><strong>{{ feedbackCenterAwaitingRecords.length }}</strong><button (click)="feedbackCenterChangeTab('inbox')">View →</button></div>
          <div class="nfc-metric"><div>Follow-up statuses <i class="bi bi-exclamation-triangle"></i></div><strong>{{ feedbackCenterFollowupRecords.length }}</strong><button (click)="feedbackCenterChangeTab('followups')">View →</button></div>
        </div>
        <div class="nfc-two-columns">
          <section class="nfc-card nfc-pad">
            <div class="nfc-section-head"><div><span class="nfc-eyebrow">PRIORITY INBOX</span><h3>Needs your attention</h3><p>Records with actionable statuses returned by the API</p></div><button type="button" class="nfc-link" (click)="feedbackCenterChangeTab('inbox')">View inbox →</button></div>
            <div class="nfc-empty" *ngIf="feedbackCenterAttentionRecords.length === 0">No feedback with an actionable status was returned for this period.</div>
            <ng-container *ngFor="let record of feedbackCenterAttentionRecords | slice:0:4">
              <div class="nfc-inbox-row">
                <div class="nfc-person-circle">{{ feedbackCenterInitials(feedbackCenterTeacherName(record.teacherId)) }}</div>
                <div class="nfc-grow"><div class="nfc-flex"><strong>{{ feedbackCenterTeacherName(record.teacherId) }}</strong><span class="nfc-pill" [ngClass]="feedbackCenterStatusClass(record)">{{ feedbackCenterStatusLabel(record) }}</span></div>
                  <small>{{ feedbackCenterCategory(record) }} · {{ record.createdOn | date : 'dd MMM yyyy' }} · {{ isFeedbackCenterRestricted(record) ? 'Restricted rating' : (record.rating + '/5 rating') }}</small>
                  <p>{{ isFeedbackCenterRestricted(record) ? 'Restricted concern — details require safeguarding authorization.' : (record.feedback || 'No comment supplied.') }}</p>
                  <button type="button" class="nfc-link" (click)="feedbackCenterOpenRecord(record)">Review feedback →</button>
                </div>
              </div>
            </ng-container>
          </section>
          <section class="nfc-card nfc-pad">
            <div class="nfc-section-head"><div><span class="nfc-eyebrow">REPORTING CONTEXT</span><h3>Feedback overview</h3><p>Descriptive snapshot · not a teacher ranking</p></div><i class="bi bi-file-earmark-bar-graph"></i></div>
            <div class="nfc-rating-big">{{ feedbackCenterAverage(feedbackCenterScopeRecords) === null ? '—' : feedbackCenterAverage(feedbackCenterScopeRecords) }}<small> / 5</small><span class="nfc-muted">{{ feedbackCenterOrdinary(feedbackCenterScopeRecords).length }} non-restricted ratings</span></div>
            <div class="nfc-rating-row" *ngFor="let n of [5,4,3,2,1]"><span>{{ n }} ★</span><div class="nfc-track"><div class="nfc-fill" [style.width.%]="feedbackCenterRatingPercent(feedbackCenterScopeRecords, n)"></div></div><span>{{ feedbackCenterRatingCount(feedbackCenterScopeRecords, n) }} ({{ feedbackCenterRatingPercent(feedbackCenterScopeRecords, n) }}%)</span></div>
            <div class="nfc-note"><i class="bi bi-info-circle"></i> Ratings reflect participating parents only. Restricted reports are excluded. Do not use scores alone for employment decisions.</div>
            <div class="nfc-mini-stats"><div><strong>{{ feedbackCenterRatingCount(feedbackCenterScopeRecords, 5) + feedbackCenterRatingCount(feedbackCenterScopeRecords, 4) }}</strong><small>Positive ratings (4–5★)</small></div><div><strong>{{ feedbackCenterRatingCount(feedbackCenterScopeRecords, 1) + feedbackCenterRatingCount(feedbackCenterScopeRecords, 2) }}</strong><small>Low ratings (1–2★), not findings</small></div></div>
          </section>
        </div>
      </ng-container>

      <section class="nfc-card nfc-pad" *ngIf="feedbackCenterTab === 'overview' || feedbackCenterTab === 'teachers'">
        <div class="nfc-section-head"><div><span class="nfc-eyebrow">TEACHER DIRECTORY</span><h3>All teachers</h3><p>View feedback with review-count context</p></div><button type="button" *ngIf="feedbackCenterTab === 'overview'" class="nfc-link" (click)="feedbackCenterChangeTab('teachers')">View all →</button></div>
        <div *ngIf="teacherGridList.length === 0" class="nfc-empty">No teachers were returned by the school teaching-staff API.</div>
        <div class="nfc-table-wrap" *ngIf="teacherGridList.length > 0"><table class="nfc-table"><thead><tr><th>Teacher</th><th>Feedback</th><th>Average</th><th>Needs attention</th><th>Action</th></tr></thead><tbody>
          <tr *ngFor="let teacher of feedbackCenterVisibleTeachers">
            <td><div class="nfc-person"><div class="nfc-person-circle">{{ feedbackCenterInitials(teacher.fullName) }}</div><div><strong>{{ teacher.fullName }}</strong><small>{{ teacher.designation || 'Teaching Staff' }}</small></div></div></td>
            <td>{{ feedbackCenterTeacherRecords(teacher.id).length }} review(s)</td>
            <td><strong>{{ feedbackCenterAverage(feedbackCenterTeacherRecords(teacher.id)) === null ? '—' : feedbackCenterAverage(feedbackCenterTeacherRecords(teacher.id)) + '/5' }}</strong><small *ngIf="feedbackCenterOrdinary(feedbackCenterTeacherRecords(teacher.id)).length > 0 && feedbackCenterOrdinary(feedbackCenterTeacherRecords(teacher.id)).length < 3" class="nfc-limited">Limited sample ({{ feedbackCenterOrdinary(feedbackCenterTeacherRecords(teacher.id)).length }})</small></td>
            <td><span class="nfc-pill" [class.nfc-closed]="feedbackCenterOpenCount(teacher.id) === 0" [class.nfc-new]="feedbackCenterOpenCount(teacher.id) > 0">{{ feedbackCenterOpenCount(teacher.id) ? feedbackCenterOpenCount(teacher.id) + ' to review' : 'No flagged items' }}</span></td>
            <td><button type="button" class="nfc-link" (click)="feedbackCenterOpenTeacher(teacher)">View teacher →</button></td>
          </tr></tbody></table></div>
      </section>

      <section class="nfc-card nfc-pad" *ngIf="feedbackCenterTab === 'inbox'">
        <div class="nfc-section-head"><div><span class="nfc-eyebrow">FEEDBACK INBOX</span><h3>All feedback</h3><p>Records and statuses from SchoolFeedback_ReadBySchoolId</p></div><span class="nfc-muted">{{ feedbackCenterDisplayRecords.length }} records shown</span></div>
        <div class="nfc-filterbar"><label>Teacher <select [(ngModel)]="feedbackCenterTeacherId" (ngModelChange)="feedbackCenterChangeFilters()"><option value="all">All teachers</option><option *ngFor="let t of teacherGridList" [value]="t.id">{{ t.fullName }}</option></select></label>
          <label>Status <select [(ngModel)]="feedbackCenterStatus" (ngModelChange)="feedbackCenterChangeFilters()"><option value="all">All statuses</option><option *ngFor="let status of feedbackCenterStatusOptions" [value]="status">{{ status }}</option></select></label>
          <label>Rating <select [(ngModel)]="feedbackCenterRating" (ngModelChange)="feedbackCenterChangeFilters()"><option value="all">All ratings</option><option *ngFor="let n of [5,4,3,2,1]" [value]="n">{{ n }} ★</option></select></label>
        </div>
        <div class="nfc-empty" *ngIf="feedbackCenterDisplayRecords.length === 0">No feedback matches these filters.</div>
        <div *ngFor="let record of feedbackCenterInboxPageItems" class="nfc-history-card">
          <div class="nfc-person"><div class="nfc-person-circle">{{ feedbackCenterInitials(feedbackCenterTeacherName(record.teacherId)) }}</div><div><strong>{{ feedbackCenterTeacherName(record.teacherId) }}</strong><small>{{ record.createdOn | date : 'dd MMM yyyy - h:mm a' }} · Parent identity protected</small></div></div>
          <span class="nfc-pill" [ngClass]="feedbackCenterStatusClass(record)">{{ feedbackCenterStatusLabel(record) }}</span>
          <div class="nfc-meta">{{ feedbackCenterCategory(record) }} · {{ isFeedbackCenterRestricted(record) ? 'Restricted rating' : (record.rating + ' / 5 ★') }}</div>
          <p>{{ isFeedbackCenterRestricted(record) ? 'Restricted feedback — use authorized safeguarding process.' : (record.feedback || 'No comment supplied.') }}</p>
          <div class="nfc-history-footer"><small>Reference #FB-{{ record.feedbackId }}</small><button type="button" class="nfc-button nfc-outline nfc-small" (click)="feedbackCenterOpenRecord(record)">Open feedback →</button></div>
        </div>
        <div class="nfc-pagination" *ngIf="feedbackCenterTotalPages > 1"><button type="button" class="nfc-button nfc-small" (click)="feedbackCenterPage = feedbackCenterPage - 1" [disabled]="feedbackCenterPage <= 1">Previous</button>Page {{ feedbackCenterPage }} of {{ feedbackCenterTotalPages }}<button type="button" class="nfc-button nfc-small" (click)="feedbackCenterPage = feedbackCenterPage + 1" [disabled]="feedbackCenterPage >= feedbackCenterTotalPages">Next</button></div>
      </section>

      <section class="nfc-card nfc-pad" *ngIf="feedbackCenterTab === 'followups'">
        <div class="nfc-section-head"><div><span class="nfc-eyebrow">FOLLOW-UPS</span><h3>Existing follow-up statuses</h3><p>Based on feedback Status only; not a substitute for the assignment workflow</p></div></div>
        <div class="nfc-note">Assign, request clarification, resolve, reopen, escalate, due dates and audit log require new authorized workflow APIs. This read-only list shows only what your current API returns.</div>
        <div class="nfc-empty" *ngIf="feedbackCenterFollowupRecords.length === 0">No follow-up statuses were found in the current scope.</div>
        <div *ngFor="let record of feedbackCenterFollowupRecords" class="nfc-follow-row"><div><strong>{{ feedbackCenterTeacherName(record.teacherId) }}</strong><p>Ref #FB-{{ record.feedbackId }} · {{ feedbackCenterCategory(record) }} · {{ record.createdOn | date : 'dd MMM yyyy' }}</p></div><span class="nfc-pill" [ngClass]="feedbackCenterStatusClass(record)">{{ feedbackCenterStatusLabel(record) }}</span><button type="button" class="nfc-link" (click)="feedbackCenterOpenRecord(record)">View →</button></div>
      </section>
    </ng-template>
  </ng-container>

  <ng-template #feedbackCenterDetailsModal let-modal>
    <div class="modal-header"><h5 class="modal-title">Feedback #FB-{{ viewedFeedbackRecord?.feedbackId }}</h5><button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button></div>
    <div class="modal-body" *ngIf="viewedFeedbackRecord as record">
      <div class="nfc-flex mb-3"><strong>{{ feedbackCenterTeacherName(record.teacherId) }}</strong><span class="nfc-pill" [ngClass]="feedbackCenterStatusClass(record)">{{ feedbackCenterStatusLabel(record) }}</span></div>
      <p class="nfc-muted">{{ record.createdOn | date : 'dd MMM yyyy - h:mm a' }} · {{ feedbackCenterCategory(record) }} · Parent identity protected</p>
      <div class="nfc-stars" *ngIf="!isFeedbackCenterRestricted(record)">{{ record.rating }} / 5 ★</div>
      <div class="nfc-review-full">{{ isFeedbackCenterRestricted(record) ? 'This is restricted feedback. Do not display the content without a dedicated safeguarding permission check on the server.' : (record.feedback || 'No written feedback provided.') }}</div>
      <div class="nfc-note"><i class="bi bi-info-circle"></i> Assignment, reply, resolution, and activity history are not returned by the current feedback APIs. No workflow change has been recorded by opening this dialog.</div>
    </div>
    <div class="modal-footer"><button class="btn btn-secondary" (click)="modal.close()">Close</button></div>
  </ng-template>

  <ng-template #feedbackCenterPrivacyModal let-modal>
    <div class="modal-header"><h5 class="modal-title">Privacy, fairness &amp; reporting</h5><button type="button" class="btn-close" (click)="modal.dismiss()"></button></div>
    <div class="modal-body">
      <p>Teacher feedback should be used for constructive school improvement, not automated personnel decisions.</p>
      <p>Reports omit parent identity and restricted comments. Average ratings exclude flagged restricted records and should always be shown with review counts.</p>
      <p>For production, the backend must verify school scope, authorization, feedback visibility level and export permission. A restricted safeguarding case must not appear in ordinary school-wide list endpoints.</p>
      <p>Academic year is displayed using April–March reporting periods; the filters work on feedback submission dates returned by the API.</p>
    </div>
    <div class="modal-footer"><button class="btn btn-secondary" (click)="modal.close()">Close</button></div>
  </ng-template>
</div>

</ng-container>
<ng-container *ngIf="!isSchoolAdmin && !!affiliationType">
<button class="universal-submit-btn" (click)="goBackToSchool()" *ngIf="isSchoolAdmin">
  <i class="bi bi-arrow-left"></i>
</button>

<div class="container-fluid px-4 py-4" *ngIf="teacherFeedbacks && teacherFeedbacks.length >= 0">
  <div class="d-flex align-items-center justify-content-between">
    <h4 class="fw-bold text-primary mb-2" style="color: #011440 !important">
      Teacher Feedback
    </h4>
    <div class="d-flex align-items-center justify-content-end mb-3 gap-2 feedback-action-row">
      <!-- Dropdown -->
      <div class="teacher-dropdown" *ngIf="false">
        <ng-select [items]="teacherList" bindLabel="fullName" bindValue="id" placeholder="Select Teacher"
          [(ngModel)]="selectedTeacherId" (change)="onTeacherChange($event)" [searchable]="true" [clearable]="true">
        </ng-select>

      </div>

      <!-- Share Feedback Button -->
      <button class="feedbackBtn" (click)="openFeedbackForm()" *ngIf="isParent">
        Share Your Feedback
      </button>
    </div>


  </div>
  <hr />

  <!-- All teaching staff. This grid is independent of the selected teacher's review summary. -->
  <div class="card border-0 shadow-sm mb-4">
    <div class="card-header bg-white d-flex justify-content-between align-items-center py-3">
      <h5 class="fw-bold mb-0" style="color: #011440;">All Teachers</h5>
      <span class="text-muted small">Total Teachers: {{ teacherGridList.length }}</span>
    </div>
    <div class="text-center my-4" *ngIf="isTeacherGridLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading teachers...</span>
      </div>
    </div>
    <div class="alert alert-warning m-3" *ngIf="!isTeacherGridLoading && teacherGridError">
      {{ teacherGridError }}
    </div>
    <div class="table-responsive" *ngIf="!isTeacherGridLoading && teacherGridList.length > 0">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light">
          <tr>
            <th scope="col">Sr. No.</th>
            <th scope="col">Teacher Name</th>
            <th scope="col" *ngIf="isSchoolAdmin">User ID</th>
            <th scope="col">Designation</th>
            <th scope="col" *ngIf="isSchoolAdmin">Mobile</th>
            <th scope="col" *ngIf="isSchoolAdmin">Email</th>
            <th scope="col" class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let teacher of teacherGridList; let i = index">
            <td>{{ i + 1 }}</td>
            <td class="fw-semibold">{{ teacher.fullName }}</td>
            <td *ngIf="isSchoolAdmin">{{ teacher.id }}</td>
            <td>{{ teacher.designation || '-' }}</td>
            <td *ngIf="isSchoolAdmin">{{ teacher.mobileNo || '-' }}</td>
            <td *ngIf="isSchoolAdmin">{{ teacher.emailId || '-' }}</td>
            <td class="text-center">
              <button type="button" class="btn btn-outline-primary btn-sm"
                (click)="viewAllTeacherFeedback(teacher)">
                <i class="bi bi-eye me-1"></i> View Feedback
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center text-muted p-4" *ngIf="!isTeacherGridLoading && teacherGridList.length === 0 && !teacherGridError">
      No teachers found for this school.
    </div>
  </div>

  <div class="container review-container" *ngIf="!isSchoolAdmin && (loadingFeedbacks || teacherFeedbacks.length > 0)">
    <!-- Review Summary -->

    <div class="text-center my-4" *ngIf="loadingFeedbacks">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div *ngIf="!loadingFeedbacks && teacherFeedbacks.length > 0">

      <div class="row">
        <div class="col-md-6">
          <h5 class="fs-4 fw-bold mb-3">Review Summary</h5>

          <div class="d-flex align-items-center">
            <div class="flex-grow-1">
              <p class="mb-1 fs-5 fw-semibold">Excellent</p>
              <div class="rating-bar">
                <div class="rating-fill" [style.width.%]="excellentPercentage"></div>
              </div>

              <p class="mb-1 fs-5 fw-semibold">Good</p>
              <div class="rating-bar">
                <div class="rating-fill" [style.width.%]="goodPercentage"></div>
              </div>

              <p class="mb-1 fs-5 fw-semibold">Average</p>
              <div class="rating-bar">
                <div class="rating-fill" [style.width.%]="avgPercentage"></div>
              </div>

              <p class="mb-1 fs-5 fw-semibold">Poor</p>
              <div class="rating-bar">
                <div class="rating-fill" [style.width.%]="poorPercentage"></div>
              </div>
            </div>

            <div class="text-center ms-3">
              <div>
                <div class="review-score">{{ overallRating }}</div>
                <ngb-rating [(rate)]="overallRating" [max]="5" [readonly]="true"></ngb-rating>
              </div>
              <small class="text-muted fs-6 fw-semibold">
                {{ teacherFeedbacks.length }} review{{ teacherFeedbacks.length > 1 ? 's' : '' }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <hr />





      <div class="feedback-cards-wrapper position-relative">
        <button class="scroll-btn me-2" *ngIf="teacherFeedbacks.length > 4"
          (click)="scrollLeft('teacherFeedbackContainer')">
          <i class="bi bi-chevron-left"></i>
        </button>
        <div id="teacherFeedbackContainer" class="feedback-cards d-flex overflow-auto">
          <div class="review-card shadow-sm h-100 d-flex flex-column me-3" *ngFor="let f of teacherFeedbacks"
            [style.flex]="'0 0 calc(25% - 12px)'">
            <p class="review-meta">{{ f.createdOn | date : 'dd/MM/yyyy - h:mm a' }}</p>
            <h6 class="fw-bold mb-1">Feedback from <span class="text-primary">{{ f.masterName }}</span></h6>

            <span class="desc-cell ellipsis-text card-desc py-1 mb-2" [ngbTooltip]="f.feedback"
              [tooltipClass]="'custom-tooltip'">
              {{ f.feedback || '-' }}
            </span>

            <ngb-rating [(rate)]="f.rating" [max]="5" [readonly]="true" class="mb-3"></ngb-rating>

            <div class="card-actions d-flex justify-content-end mt-auto"
              [ngClass]="{ 'invisible': f.masterId !== this.User.userId }">
              <i class="fa-solid fa-pen me-2" (click)="handleActionClick({ actionName: 'Edit', rowData: f })"></i>
              <i class="fa-solid fa-trash" (click)="handleActionClick({ actionName: 'Delete', rowData: f })"></i>
            </div>

          </div>
        </div>

        <button class="scroll-btn ms-2" *ngIf="teacherFeedbacks.length > 4"
          (click)="scrollRight('teacherFeedbackContainer')">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>



    <!-- <div class="noFeedbackMessage text-center mt-4" *ngIf="!loadingFeedbacks && teacherFeedbacks.length === 0">
      <div class="no-feedback-box">
        <h4>No feedback submitted for teachers yet.<br />
          Be the first to share your experience!</h4>
      </div>
    </div> -->

  </div>

  <!-- Feedback Modal Template -->
  <ng-template #feedbackTemplate>
    <div class="modal-header">
      <h5 class="modal-title">{{ isEditMode ? 'Edit' : 'Add' }} Feedback</h5>
      <button type="button" class="btn-close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="feedbackForm" class="p-2">
        <div class="mb-3">
          <label class="form-label">Select Teacher <span class="text-danger">*</span></label>
          <ng-select [items]="teacherList" bindLabel="fullName" bindValue="id" formControlName="teacherId"
            [searchable]="true" [clearable]="false">
          </ng-select>


          <small class="text-danger"
            *ngIf="feedbackForm.get('teacherId')?.touched && feedbackForm.get('teacherId')?.invalid">
            Teacher is required
          </small>
        </div>
        <div class="mb-3">
          <label class="form-label">Overall Teaching Experience <span class="text-danger">*</span></label>

          <select class="form-select" formControlName="experienceLevel" (change)="handleChangeExperienceLevel($event)">
            <option value="" disabled selected>Select Experience Level</option>
            <option value="best">Best</option>
            <option value="better">Better</option>
            <option value="good">Good</option>
            <option value="fair">Fair</option>
            <option value="poor">Poor</option>
          </select>

          <small class="text-danger" *ngIf="feedbackForm.get('experienceLevel')?.touched &&
           feedbackForm.get('experienceLevel')?.invalid">
            Experience level is required
          </small>
        </div>

        <div class="mb-3">
          <label class="form-label">Rate Your Experience</label>
          <ngb-rating [rate]="feedbackForm.get('rating')?.value!" [max]="5" [readonly]="true">
          </ngb-rating>

        </div>

        <div class="mb-3">
          <label class="form-label">Description (Optional)</label>
          <textarea class="form-control" rows="4" formControlName="feedback" maxlength="1000"></textarea>
          <p class="text-end text-muted">{{ feedbackForm.get('feedback')?.value?.length || 0 }}/1000</p>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="universal-submit-btn" [disabled]="isSubmitting" (click)="submitFeedback()">
        {{ isSubmitting ? (isEditMode ? 'Updating...' : 'Saving...') : (isEditMode ? 'Update' : 'Submit') }}
      </button>
      <button type="button" class="universal-cancel-btn" (click)="closeModal()">Close</button>
    </div>
  </ng-template>

  <!-- Separate read-only popup: loads every feedback returned by the selected teacher's API. -->
  <ng-template #teacherFeedbackDetailsTemplate let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Teacher Feedback — {{ selectedFeedbackTeacher?.fullName || '-' }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="row g-3 mb-3" *ngIf="selectedFeedbackTeacher as teacher">
        <div class="col-md-6"><strong>Teacher:</strong> {{ teacher.fullName }}</div>
        <!-- <div class="col-md-6" *ngIf="isSchoolAdmin"><strong>User ID:</strong> {{ teacher.id }}</div> -->
        <div class="col-md-6"><strong>Designation:</strong> {{ teacher.designation || '-' }}</div>
        <div class="col-md-6" *ngIf="isSchoolAdmin"><strong>Mobile:</strong> {{ teacher.mobileNo || '-' }}</div>
        <div class="col-md-6" *ngIf="isSchoolAdmin"><strong>Email:</strong> {{ teacher.emailId || '-' }}</div>
      </div>

      <div class="text-center py-4" *ngIf="isTeacherFeedbackModalLoading">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading feedback...</span>
        </div>
        <p class="mt-2 mb-0">Loading teacher feedback...</p>
      </div>

      <div class="alert alert-warning" *ngIf="!isTeacherFeedbackModalLoading && teacherFeedbackModalError">
        {{ teacherFeedbackModalError }}
      </div>

      <ng-container *ngIf="!isTeacherFeedbackModalLoading && !teacherFeedbackModalError">
        <div class="d-flex align-items-center gap-3 mb-3" *ngIf="selectedTeacherModalFeedbacks.length > 0">
          <strong>Total Reviews: {{ selectedTeacherModalFeedbacks.length }}</strong>
          <span>Average Rating: {{ teacherFeedbackModalAverage }} / 5</span>
          <ngb-rating [rate]="teacherFeedbackModalAverage" [max]="5" [readonly]="true"></ngb-rating>
        </div>

        <div class="alert alert-light border" *ngIf="selectedTeacherModalFeedbacks.length === 0">
          No feedback submitted for this teacher yet.
        </div>

        <div class="table-responsive" *ngIf="selectedTeacherModalFeedbacks.length > 0">
          <table class="table table-striped table-bordered align-middle">
            <thead class="table-light">
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Feedback By</th>
                <th scope="col">Rating</th>
                <th scope="col">Feedback</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let feedback of selectedTeacherModalFeedbacks; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ feedback.masterName || '-' }}</td>
                <td>
                  <ngb-rating [rate]="feedback.rating" [max]="5" [readonly]="true"></ngb-rating>
                  <span class="ms-2">{{ feedback.rating }} / 5</span>
                </td>
                <td style="white-space: pre-wrap; overflow-wrap: anywhere;">{{ feedback.feedback || '-' }}</td>
                <td>{{ feedback.createdOn | date : 'dd/MM/yyyy - h:mm a' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
    </div>
  </ng-template>
</div>

</ng-container>
